import { render, staticRenderFns } from "./comment-review.vue?vue&type=template&id=03b985e1&scoped=true&"
import script from "./comment-review.vue?vue&type=script&lang=js&"
export * from "./comment-review.vue?vue&type=script&lang=js&"
import style0 from "./comment-review.vue?vue&type=style&index=0&id=03b985e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b985e1",
  null
  
)

export default component.exports